<script>
import ChildStatusTransitionRepository from '../../js/repository/ChildStatusTransitionRepository';
import DataProvider from './DataProvider.vue';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        id: {
            type: Number,
            required: true,
        }
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: ChildStatusTransitionRepository.findForChild,
                params: [this.id]
            },
            scopedSlots: this.$scopedSlots,
        });
    }
}
</script>
